import { UnifiedField } from 'generated/graphql';

export const getUnifiedFieldsDataGridRows = (data?: UnifiedField[]) => {
  if (!data) {
    return [];
  }

  return data.map((field, index) => ({
    id: `${field.eqlField.displayName}-${index}`,
    name: field.eqlField.displayName,
    totalMergeFields: field.eqlField.detail?.metadata?.references?.length,
    sources: field.eqlField.detail?.metadata?.references,
    field: field.eqlField.field,
    sampleValues: field.values.map((value) => value.displayName).join(', '),
  }));
};
